import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-background text-foreground font-heading">
      <Navbar />
      
      <div className="pt-32 pb-20 px-6 md:px-12 max-w-[900px] mx-auto">
        <h1 className="text-4xl md:text-5xl font-light mb-2 leading-[1.1]">Vilkår for bruk</h1>
        <p className="text-lg text-foreground/60 mb-12">Sist oppdatert: {new Date().toLocaleDateString('nb-NO')}</p>

        <div className="space-y-8 font-serif text-lg leading-relaxed text-foreground/80">
          <section>
            <h2 className="text-2xl font-light mb-4 text-foreground">1. Godtakelse av vilkår</h2>
            <p>
              Ved å bruke LYKKE NOMARs nettside godtar du disse vilkårene for bruk helt og holdent. 
              Hvis du ikke godtar disse vilkårene, ber vi deg om å ikke bruke nettsiden.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-light mb-4 text-foreground">2. Bruk av nettstedet</h2>
            <p className="mb-4">Du godtar å bruke nettsiden kun til lovlige formål og på en måte som ikke:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Krenker noen andres rettigheter</li>
              <li>Forstyrrer eller hindrer bruken av nettsiden</li>
              <li>Introduserer virus eller skadelig kode</li>
              <li>Brukes til spam eller phishing</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-light mb-4 text-foreground">3. Intellektuelle rettigheter</h2>
            <p>
              Alt innhold på nettsiden, inkludert tekst, bilder, logoer og designelementer, 
              er beskyttet av opphavsrett og tilhører LYKKE NOMAD AS eller dens lisensgivere. 
              Du har ikke lov til å reprodusere, distribuere eller endre innholdet uten tillatelse.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-light mb-4 text-foreground">4. Nøyaktighet av informasjon</h2>
            <p>
              Vi bemstrer oss om å gi nøyaktig informasjon, men garanterer ikke at all informasjon 
              på nettsiden er korrekt, fullstendig eller oppdatert. Prisene og tilgjengeligheten 
              er gjenstand for endring uten varsel.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-light mb-4 text-foreground">5. Ansvarsfraskrivelse</h2>
            <p>
              Nettsiden stilles til rådighet som den er, uten garantier av noe slag, verken uttrykkelig 
              eller underforstått. Vi er ikke ansvarlig for tap eller skader som oppstår fra bruk av nettsiden.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-light mb-4 text-foreground">6. Bestillinger og priser</h2>
            <p className="mb-4">
              Når du sender en konfigurasjonsforespørsel gjennom vår konfigurator, anses dette som en forespørsel 
              om tilbud, ikke et bindende tilbud. Vi vil kontakte deg med et formelt tilbud basert på dine spesifikasjoner.
            </p>
            <p>
              Alle priser er i NOK og inkluderer mva. Leveringskostnader vil bli beregnet basert på adresse.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-light mb-4 text-foreground">7. Betaling</h2>
            <p>
              Betaling skal skje som avtalt i faktura. Dersom betaling ikke mottas innen forfallsdato, 
              har vi rett til å kreve dørende rente og krystallingskostnader.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-light mb-4 text-foreground">8. Leveranse</h2>
            <p>
              Leveringstid vil bli avtalt separat for hver ordre. Vi forsøker å levere rettidlig, 
              men kan ikke holdes ansvarlig for forsinkelser som skyldes forhold utenfor vår kontroll.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-light mb-4 text-foreground">9. Reklamasjoner</h2>
            <p>
              Reklamringer over produktets kvalitet må meldes skriftlig innen 8 dager etter mottak. 
              Foto eller video som dokumentasjon skal vedlegges.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-light mb-4 text-foreground">10. Ansvarsbegrensning</h2>
            <p>
              Vår totalansvar for direkte og indirekte tap eller skader skal ikke overstige beløpet 
              du har betalt for produktet eller tjenesten.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-light mb-4 text-foreground">11. Gjeldende lovgivning</h2>
            <p>
              Disse vilkårene er underlagt norsk lov og tolkes i samsvar med norske rettsregler. 
              Eventuelle tvister vil løses ved domstol i Norge.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-light mb-4 text-foreground">12. Kontakt oss</h2>
            <p>
              For spørsmål om disse vilkårene, vennligst kontakt:{' '}
              <a href="mailto:kontakt@lykke.info" className="underline hover:opacity-70">
                kontakt@lykke.info
              </a>
            </p>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
}